export default {
  computed: {
    truckAdded() {
      if (_.isEmpty(this.flight)) {
        return false
      }

      return this.flight.state_numbers && this.flight.state_numbers.length
    },
    truckNumber() {
      if (_.isEmpty(this.flight)) {
        return false
      }

      return this.flight.state_numbers && this.flight.state_numbers.length
        ? this.flight.state_numbers
        : 'Не назначено'
    },
    formattedDate() {
      if (_.isEmpty(this.flight)) {
        return ''
      }
      let date = this.flight.load_date.split('-')
      date[0] = date[0].slice(2)

      return date.reverse().join('.')
    },

    loadAddress() {
      if (_.isEmpty(this.flight)) {
        return ''
      }

      let address = this.flight.load_point.split(',')
      let town = address[1].replace(/&nbps;/g, ' ').split(' ')
      town.shift()

      return address[0] + ', ' + town.join(' ')
    },
    unloadAddress() {
      if (_.isEmpty(this.flight)) {
        return ''
      }

      let town = this.flight.unload_point.split(',')[1]

      return (
        this.flight.cargo_receiver_name +
        ', ' +
        town.charAt(0).toLowerCase() +
        town.slice(1)
      )
    },
    flightDeliveryPrice() {
      if (_.isEmpty(this.flight)) {
        return 0
      }

      return Number(this.flight.price_from_storage_driver).toFixed(2)
    },
    flightHarvestPrice() {
      if (_.isEmpty(this.flight)) {
        return 0
      }

      return Number(this.flight.price_from_field_driver).toFixed(2)
    },
    // не используется в случае Перевозка+уборка, поэтому два варианта
    flightPrice() {
      if (_.isEmpty(this.flight)) {
        return 0
      }

      return this.flight.type_code === 'delivery'
        ? this.flightDeliveryPrice
        : this.flightHarvestPrice
    },
  },
}
